<script>
export default defineComponent({
  name: "WhatWeOffer",
  data() {
    return {
      data: [
        {
          icon: "/img/icon-11.svg",
          title: this.$t("membership.whatWeOffer.meetingRooms"),
        },
        {
          icon: "/img/icon-3.svg",
          title: this.$t("membership.whatWeOffer.atmosphere"),
        },
        {
          icon: "/img/icon-9.svg",
          title: this.$t("membership.whatWeOffer.events"),
        },
        {
          icon: "/img/icon-13.svg",
          title: this.$t("membership.whatWeOffer.cafe"),
        },        
				{
          icon: "/img/icon-12.svg",
          title: this.$t("membership.whatWeOffer.hearth"),
        },
				
				// {
        //   icon: "/img/icon-4.svg",
        //   title: this.$t("membership.whatWeOffer.networking"),
        // },
        {
          icon: "/img/icon-2.svg",
          title: this.$t("membership.whatWeOffer.manager"),
        },
        // {
        //   icon: "/img/icon-7.svg",
        //   title: this.$t("membership.whatWeOffer.post"),
        // },
        
      ],
    };
  },
});
</script>

<template>
  <div>
    <div v-if="false" class="flex justify-center">
      <div class="max-w-7xl lg:flex gap-12 p-6 py-16 lg:py-24 w-full">
        <div class="">
          <h2 class="h1" v-html="$t('membership.whatWeOffer.title')"></h2>
        </div>
      </div>
    </div>
    <div class="md:grid gap-x-12 grid-cols-2">
      <div v-for="(d, i) in data" :key="i" class="flex mt-6">
        <img class="h-10 mr-4" :src="d.icon" />
        <p>{{ d.title }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
p {
  font-size: 20px;
}
</style>
